import { Wrapper } from '@american-autonomy/ag-ui';

import Modal from 'components/Modal';
import GhostButton from 'components/buttons/GhostButton';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

// Thin Modal wrapper used by PrescriptionSection to surface invalid-polygon
// and unsupported-CRS parser warnings. No styles file — the wrapped Modal
// owns its own appearance and we only need a single text Wrapper for the
// body. Existence of this subcomponent is a 100-line-budget concession;
// the section root cannot fit the modal inline.
const WarningDialog: FunctionComponent<Props> = ({
    cancelText,
    className,
    isOpen,
    message,
    onDismiss,
    testId = TEST_ID,
    title
}) => (
    <Modal
        className={className}
        footer={<GhostButton onClick={onDismiss} text={cancelText} />}
        isOpen={isOpen}
        onClose={onDismiss}
        size='small'
        testId={testId}
        title={title}>
        <Wrapper>{message}</Wrapper>
    </Modal>
);

export default WarningDialog;
